import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { down } from '../../../styles/media';

export const Panel = styled.div`
  display: grid;
  gap: 1.2rem;
  /* Não usar auto-fit aqui: o wrapper do dropdown tem width: max-content, e
     sob esse tipo de dimensionamento o auto-fit colapsa sempre para 1 coluna.
     O nº de colunas vem do componente — 1 no menu mobile, 2/3 no desktop. */
  grid-template-columns: ${({ columns }) =>
    columns === 1
      ? 'minmax(0, 1fr)'
      : `repeat(${columns}, minmax(220px, 1fr))`};

  /* Tela larga mantém as 3 colunas originais; conforme estreita, o painel
     passa a 2 colunas em vez de ocupar a viewport inteira. */
  ${({ columns }) =>
    columns > 2 &&
    css`
      ${down('xl')} {
        grid-template-columns: repeat(2, minmax(200px, 1fr));
      }
    `}
`;

export const Card = styled(NavLink)`
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  padding: 1rem 1.125rem;
  border-radius: 0.625rem;
  background: #f8faf9;
  border: 1px solid #e2ece5;
  text-align: left;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease, transform 0.2s ease;

  @media (hover: hover) {
    &:hover {
      background: var(--white-color);
      border-color: var(--second-color);
      box-shadow: 0 4px 14px rgba(0, 137, 58, 0.1);
      transform: translateY(-2px);
    }
  }

  ${down('md')} {
    padding: 0.65rem 0.85rem;
    gap: 0.65rem;
    border-radius: 0.5rem;
  }
`;

export const IconCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0.5rem;
  border-radius: 0.5rem;
  background: #e9f2eb;
  color: var(--second-color);
  transition: background-color 0.2s ease, color 0.2s ease;

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  @media (hover: hover) {
    ${Card}:hover & {
      background: var(--second-color);
      color: var(--white-color);
    }
  }

  ${down('md')} {
    padding: 0.4rem;
    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
`;

export const CardText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;

  strong {
    color: var(--first-color);
    font-size: 0.9375rem;
    font-weight: 700;
  }

  span {
    color: var(--octave-color);
    font-size: 0.75rem;
    line-height: 1.35;
  }

  ${down('md')} {
    strong {
      font-size: 0.875rem;
    }
    span {
      font-size: 0.7rem;
    }
  }
`;
